import { useEffect, useState } from "react";
import { getCustomisationValue, updateCustomisationValue } from "../../../EditablePreview/EditablePreview";
import './CopyModule.scss';
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";

const CopyModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    const [currentCopy, setCurrentCopy] = useState(getCustomisationValue(customisationVars, moduleConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || '');
    useEffect(() => {
        setCurrentCopy(getCustomisationValue(customisationVars, moduleConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || '');
    }, [customisationVars, moduleConfig.dataLink]);

    const changeCopyFieldValue = (field, value) => {
        if (moduleConfig?.dataLink) {
            if (updateCustomisationValue(customisationVars, moduleConfig.dataLink, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Copy</h5>

            {renderFirstCustomBlock(props)}

            <div className="v2-module-columns-holder">
                <div className='v2-module-one-column v2-full-width' style={{marginTop: '0.5rem'}}>
                    {moduleConfig.multiline && 
                        <textarea
                            className="v2-module-input"
                            rows="5"
                            value={currentCopy}
                            onChange={(e) => setCurrentCopy(e.target.value)}
                            onBlur={(e) => changeCopyFieldValue('copy-text', e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Escape') {
                                    setCurrentCopy(getCustomisationValue(customisationVars, moduleConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || '');
                                }
                            }}
                        />
                    }
                    {!moduleConfig.multiline &&
                        <input
                            className="v2-module-input"
                            type="text"
                            value={currentCopy}
                            onChange={(e) => setCurrentCopy(e.target.value)}
                            onBlur={(e) => changeCopyFieldValue('copy-text', e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    changeCopyFieldValue('copy-text', e.target.value);
                                }
                                if (e.key === 'Escape') {
                                    setCurrentCopy(getCustomisationValue(customisationVars, moduleConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) || '');
                                }
                            }}
                        />
                    }
                </div>
            </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default CopyModule;
